<template>
  <div :class="wrapperClass">
    <label v-if="showLabel" class="text-xs text-gray-500 mr-2">{{ label }}</label>
    <select
      :value="current"
      @change="onChange($event.target.value)"
      class="border rounded-md text-sm px-2 py-1"
    >
      <option v-for="opt in options" :key="opt" :value="opt">{{ opt }}</option>
    </select>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useCurrencyStore } from '@/store/currency'
import { saveUserCurrencyPreference } from '@/services/utils/userLocation'

import { SUPPORTED_CURRENCIES } from '@/config/regional'

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: 'Currency' },
  showLabel: { type: Boolean, default: true },
  wrapperClass: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const currencyStore = useCurrencyStore()
const options = SUPPORTED_CURRENCIES.map(c => c.code)
const current = ref('AUD')

const onCurrencyChanged = (e) => {
  const val = e?.detail
  if (val && options.includes(val)) {
    current.value = val
  }
}

onMounted(() => {
  // Initialize from store or props
  current.value = props.modelValue || currencyStore.selectedCurrency || 'AUD'
  window.addEventListener('currency-changed', onCurrencyChanged)
})

onUnmounted(() => {
  window.removeEventListener('currency-changed', onCurrencyChanged)
})

watch(
  () => props.modelValue,
  (val) => {
    if (val && options.includes(val)) {
      current.value = val
    }
  }
)

const onChange = (val) => {
  current.value = val

  // Mark as explicit user preference (prevents geo-detection from overwriting)
  saveUserCurrencyPreference(val)

  // Update store (which handles localStorage and events)
  currencyStore.setCurrency(val)

  // Also emit for v-model compatibility
  emit('update:modelValue', val)
}
</script>
